import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button, DialogActions, DialogContent, DialogTitle
} from '@mui/material';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { translate } from 'utils/helpers';
import sanitizeHtml from 'sanitize-html';

export const ErrorModal = ({
  onClose, afterClose, text, title
}) => {
  const handleClose = () => {
    onClose();
    afterClose && afterClose();
  };

  return (
    <Fragment>
      <DialogTitle className="errorModal">
        <FontAwesomeIcon icon={faTimes} />
        {translate(title)}
      </DialogTitle>

      <DialogContent dangerouslySetInnerHTML={{ __html: sanitizeHtml(text) }} />

      <DialogActions>
        <Button color="primary" onClick={handleClose}>
          {translate('button.close')}
        </Button>
      </DialogActions>
    </Fragment>
  );
};

ErrorModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  afterClose: PropTypes.func,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({})
  ]),
  title: PropTypes.string
};

ErrorModal.defaultProps = {
  afterClose: () => { },
  text: '',
  title: 'errors.error'
};
